module.exports = __webpack_public_path__ + "static/abiliticbt-logo-en-01b4c6aecd0b0aacc87949c700f7e587.png";